import axios from 'axios'
import { message } from 'ant-design-vue';
import {getMessage} from "./errcodeUtil";

let request = axios.create({
  baseURL: '/api/v1',
  timeout: 60000,
  withCredentials: true
})

const urls = ['/msg/thing/property/set', '/msg/thing/property/get', '/msg/thing/service/invoke', '/mock/event/pub', '/mock/cmd/sub']

//POST传参序列化(添加请求拦截器)
request.interceptors.request.use((config) => {
  //在发送请求之前做某件事
  console.log(config)
  // if (config.url === '/system/account/login') {
  //     config.headers['IDZH-APP-ID'] = 'idianzhihuiPms';
  // } else {
  //     config.headers['IDZH-APP-ID'] = 'idianzhihuiIot';
  // }
  config.headers['IDZH-APP-ID'] = 'idianzhihuiConsole';
  config.headers['IDZH-TENANT-CODE'] = 'idianzhihui';
  return config;
}, (error) => {
  // eslint-disable-next-line no-console
  console.log('错误的传参')
  return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
request.interceptors.response.use((res) => {
  console.log(res)
  let url = res.config.url
  let result = res.data;
  if (result.code === 0) {
    if (urls.indexOf(url) !== -1) {
      return Promise.resolve(result);
    }
    return Promise.resolve(result.data);
  } else {
    return Promise.reject("errcode:" + result.code + ",errmsg:" + result.message)
  }
}, (error) => {
  let status = error.response.status;
  switch (status) {
    case 400:
      break;
    case 401:
      break;
    case 403:
      break;
    case 500:
      if (error.response.data.code) {
        let msg = getMessage(error.response.data.code);
        if (msg) {
          message.warning(getMessage(error.response.data.code));
        } else {
          message.error('系统异常');
        }
      } else {
        message.error('系统异常');
      }
      break;
  }
  return Promise.reject(error);
});

let get = (url, params) => request.get(url, {params});
let post = (url, data) => request.post(url, data);
let put = (url, data) => request.put(url, data);
let deletes = (url, data) => request.delete(url, {data});
let postMultipart = (url, data) => request.post(url, data, {
  headers: {
    credentials: 'same-origin',
  },
});

export default {
  get, post, put, deletes,postMultipart
}
